module.exports = __webpack_public_path__ + "media/images/expe_vertical-065e962e1e8d0d29546d2d610bc067e6.svg";